export default __webpack_public_path__ + "static/media/Joker.e1b8ccb9.png";